import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { config } from '../constants/domainConfig';
import {
    setFavouriteGames,
    setGames,
    setHistoryGames,
    setMovieFavourite,
    setMovieHistory,
    setMovies,
    setVideoFavourite,
    setVideoHistory,
    setVideos,
} from '../redux/actions';
import makeApiRequest from '../utils/makeApiRequest';

const useInit = () => {
    const [status, setStatus] = useState('idle');
    const dispatch = useDispatch();
    const token = useSelector((state) => state.user.token);

    const execute = useCallback(async () => {
        const authorization = sessionStorage.getItem('authorization');
        setStatus('loading');
        const [contents, history, favorites, movies, games, favoritesGames, gamesHistory] = await Promise.allSettled([
            makeApiRequest({
                url: new URL(window.location.origin + `/api/videos/v2?lang=${config.lang}&subdomain=${config.subdomain}&product=${config.product}`).href,
                method: 'GET',
                headers: { authorization },
            }),
            makeApiRequest({
                url: new URL(window.location.origin + '/api/videos/history/get?token=' + token).href,
                method: 'GET',
                headers: { authorization },
            }),
            makeApiRequest({
                url: new URL(window.location.origin + '/api/videos/fav/get?token=' + token).href,
                method: 'GET',
                headers: { authorization },
            }),
            makeApiRequest({
                url: new URL(window.location.origin + '/api/videos/movies').href,
                method: 'GET',
                headers: { authorization },
            }),
            makeApiRequest({
                url: new URL(window.location.origin + '/api/games').href,
                method: 'GET',
                headers: { authorization },
            }),
            makeApiRequest({
                url: new URL(window.location.origin + '/api/games/fav/get?token=' + token).href,
                method: 'GET',
                headers: { authorization },
            }),
            makeApiRequest({
                url: new URL(window.location.origin + '/api/games/history/get?token=' + token).href,
                method: 'GET',
                headers: { authorization },
            }),
        ]);
        if (contents.status === 'fulfilled' && contents.value.success) {
            dispatch(setVideos(contents.value.payload));
            if (history.status === 'fulfilled' && history.value.success) {
                dispatch(setVideoHistory(history.value.payload));
                dispatch(setMovieHistory(history.value.payload));
            }
            if (favorites.status === 'fulfilled' && favorites.value.success) {
                dispatch(setVideoFavourite(favorites.value.payload));
                dispatch(setMovieFavourite(favorites.value.payload));
            }
            if (movies.status === 'fulfilled' && movies.value.success) dispatch(setMovies(movies.value.payload));
            setStatus('success');
            if (games.status === 'fulfilled' && games.value.success) dispatch(setGames(games.value.payload));
            setStatus('success');
            if (favoritesGames.status === 'fulfilled' && favoritesGames.value.success) {
                dispatch(setFavouriteGames(favoritesGames.value.payload));
            }
            if (gamesHistory.status === 'fulfilled' && gamesHistory.value.success) {
                dispatch(setHistoryGames(gamesHistory.value.payload));
            }
        } else {
            setStatus('failure');
        }
    }, [dispatch, token]);

    useEffect(() => {
        execute();
    }, [execute]);

    return { status };
};

export default useInit;
